<template lang="pug">
    div
        v-menu(offset-y)
            template(v-slot:activator="{ on }")
                div.moreWrapper(v-on="on")
                    div.name {{ activeText ? activeText : name }}
                    div.icon
                        v-icon.moreIcon expand_more

            v-list.filterList
                v-list-tile(
                    v-for="(item, index) in sortedFilterItems"
                    :key="index"
                    @click="setValue(item)"
                )
                    v-list-tile-title(
                        :class="item.title === activeText ? 'isActive' : ''"
                        v-html="item.title"
                    )
</template>

<script>
    import VueTypes from 'vue-types';
    import sortBy from 'lodash/sortBy';

    export default {
        props: {
            name: VueTypes.string.def(''),
            value: VueTypes.any.def(''),
            items: VueTypes.array.def([]),
            callbackFunction: VueTypes.func.def(() => {}),
            filterName: VueTypes.string.def('')
        },
        data() {
            return {
                activeText: ''
            };
        },
        computed: {
            sortedFilterItems: function() {
                const [first, ...rest] = this.items;
                return [
                    first,
                    ...sortBy(rest, [
                        item => (item.title ? item.title.toLowerCase() : '')
                    ])
                ];
            }
        },
        watch: {
            value() {
                this.setPredefinedValue();
            }
        },
        created() {
            this.setPredefinedValue();
        },
        methods: {
            setPredefinedValue() {
                if (this.value !== undefined && this.value !== null) {
                    this.items.map(item => {
                        if (item.value === this.value) {
                            this.activeText = item.title;
                        }
                    });
                }
            },
            /**
             * Set filter value
             * @param {object} item
             */
            setValue(item) {
                if (this.filterName === 'instructor') {
                    this.callbackFunction(item);
                } else {
                    this.callbackFunction({
                        value: item.value,
                        name: this.filterName
                    });
                }

                this.activeText = item.title;
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl";

    .moreWrapper
        display: flex
        align-items: center
        cursor: pointer

    .moreIcon
        background-color: $theme.inputBackground
        border-radius: 50%
        font-size: 20px

    .name
        margin-right: 10px
        margin-bottom: 2px

    >>> a
        &.v-list__tile--link
            &:hover,
            & > .isActive
                background: transparent !important
                color: $theme.action

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .moreIcon
            background-color: $theme.inputBackground
            border-radius: 50%
            font-size: 18px
</style>
